import { Box, Button, Flex } from "@chakra-ui/react";
import { ErrorBoundary } from "react-error-boundary";
import {
  ArrayParam,
  BooleanParam,
  QueryParamProvider,
  StringParam,
  withDefault,
} from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { AppFullFallbackComponent } from "../components/lib";
import { PublicDashboardUrlParams } from "../constants";

export const AppResetBoundary = () => {
  const handleReset = () => {
    window.location.reload();
  };

  return <Button onClick={handleReset}>Refresh page</Button>;
};

const StatsLayout = ({ children }) => {
  return (
    <QueryParamProvider
      adapter={ReactRouter6Adapter}
      options={{
        includeKnownParams: true,
        params: {
          [PublicDashboardUrlParams.registry]: StringParam,
          [PublicDashboardUrlParams.switch]: BooleanParam,
          [PublicDashboardUrlParams.hideCharts]: withDefault(ArrayParam, []),
        },
      }}
    >
      <Box h="100vh" w="100vw" minW={"5xl"}>
        <Flex h="full" w="full" id="app-container">
          {/* Route */}
          <ErrorBoundary
            fallbackRender={({ error }) => (
              <AppFullFallbackComponent
                error={error}
                resetComponent={<AppResetBoundary />}
              />
            )}
          >
            <Box id="app-route" bg="bg.main" flex="1" overflow="hidden">
              {children}
            </Box>
          </ErrorBoundary>
        </Flex>
      </Box>
    </QueryParamProvider>
  );
};

export default StatsLayout;
